const PhotoPanelActions = {
  TakePhoto: "PhotoPanel_TakePhoto",
  ClosePhotoPanel: "PhotoPanel_ClosePhotoPanel",
  OpenTypeSelectionPanel: "PhotoPanel_OpenTypeSelectionPanel",
  ClearDocFaceSelection: "PhotoPanel_ClearDocFaceSelection",
};

const PhotoPanelEvents = {
  PhotoPanelOpened: "PhotoPanel_Opened",
  PhotoPanelTakePhotoOn: "PhotoPanel_TakePhotoOn",
  PhotoPanelTakePhotoOff: "PhotoPanel_TakePhotoOff",
  PhotoTaken: "PhotoPanel_PhotoTaken",
  PhotoCancelled: "PhotoPanel_PhotoCancelled",
  PhotoUploaded: "PhotoPanel_PhotoUploaded",
};

export { PhotoPanelActions, PhotoPanelEvents };
